import React, {useState} from 'react';

import {useCallChatRoom, useMediaQueries} from 'presentation/pages/private/hooks';

import {ChatRoomsEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {useReverseNetworkOrder} from 'presentation/hooks/useReverseNetworkOrder';
import {UNITS_CHANNELS_CONTACTS} from 'presentation/modules/booking/shared/constants/unitsChannelsContacts';
import {useHealthNetworkVisibility} from '../../../../hooks/useHealthNetworkVisibility';

export function useEmptyAppointmentsCard() {
	const {isMobile} = useMediaQueries();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [openPhoneDrawerState, setOpenPhoneDrawerState] = useState<boolean>(false);
	const {dataHostNameState, isGndiSaoPaulo} = useHostName();
	const isPhoneNumberMenuOpen = Boolean(anchorEl);
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();
	const phoneNumbers = UNITS_CHANNELS_CONTACTS[dataHostNameState.product].phones;
	const phoneNumbersAlert = UNITS_CHANNELS_CONTACTS[dataHostNameState.product].alert;
	const {shouldReverseNetworkOrder} = useReverseNetworkOrder({flowType: 'HEALTH'});
	const {showAccreditedNetworkToHap} = useHealthNetworkVisibility();

	const showDivider =
		(isGndiSaoPaulo || showAccreditedNetworkToHap) && !shouldReverseNetworkOrder;

	const handleOpenPhoneMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
		if (isMobile) {
			setOpenPhoneDrawerState(true);
			return;
		}
		setAnchorEl(event.currentTarget);
	};

	const handleTogglePhoneDrawer = () => {
		setOpenPhoneDrawerState(prev => !prev);
	};

	const handleClosePhoneMenu = () => {
		setAnchorEl(null);
	};

	const handleCallChatRoom = async () => {
		await callChatRoom(ChatRoomsEnum.APP);
	};

	return {
		isMobile,
		anchorEl,
		openPhoneDrawerState,
		isPhoneNumberMenuOpen,
		handleOpenPhoneMenu,
		handleTogglePhoneDrawer,
		handleClosePhoneMenu,
		handleCallChatRoom,
		phoneNumbers,
		phoneNumbersAlert,
		callChatRoomIsLoading,
		showDivider,
	};
}
